import delegate from "delegate-it";
import { fireEvent } from "@/scripts/common/util";
import ajax from "@/scripts/common/ajax";
import { updateQueryParams } from "@/scripts/common/util";
import "./search-caregivers.css";

const sidebarFiltersForm = document.querySelector(".sidebar-filters-form");
const sidebarFilterKeys = Array.from(document.querySelectorAll("[data-filter-key]")).map((x) => x.dataset.filterKey);

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  fireEvent("results:update", document.documentElement, {
    selectedFilters: JSON.parse(res.selectedFiltersJson),
    selectedCities: JSON.parse(res.selectedCitiesJson),
  });
};

const handleSortChange = (e) => {
  const selected = e.delegateTarget.dataset.sort;

  const url = updateQueryParams([["sort", selected]]);

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleViewChange = (e) => {
  const url = updateQueryParams([["view", e.delegateTarget.dataset.changeView]]);

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleSidebarFilterChange = () => {
  const filtersFormData = new FormData(sidebarFiltersForm);
  const selectedFilters = new Map(sidebarFilterKeys.map((key) => [key, new Set()]));

  for (const [name, value] of filtersFormData.entries()) {
    if (selectedFilters.has(name)) {
      selectedFilters.get(name).add(value);
    }
  }

  const params = [...selectedFilters].map(([key, set]) => [key, set.size ? [...set].join("_") : false]);
  const url = updateQueryParams(params);

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleSearchSubmit = (e) => {
  e.preventDefault();

  const data = new FormData(sidebarFiltersForm);
  const cities = data
    .getAll("cities[]")
    .filter((str) => str.trim() !== "")
    .join("_");
  const name = data.get("name");

  const url = updateQueryParams([
    ["times", false],
    ["days", false],
    ["transporation", false],
    ["languages", false],
    ["name", name],
    ["cities", cities],
  ]);

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleClearAll = (e) => {
  e.preventDefault();

  window.history.replaceState({}, "", e.delegateTarget.href);

  updateResults();

  sidebarFiltersForm.querySelectorAll("input[type=search]").forEach((x) => (x.value = null));
  sidebarFiltersForm.querySelectorAll("input[type=checkbox]").forEach((x) => (x.checked = false));
};

const handlePrint = () => {
  const url = new URL(window.location.href);
  url.searchParams.set("print", "1");

  window.open(url, "_blank");
};

const handleDownload = () => {
  const url = new URL(window.location.href);
  url.pathname = url.pathname + "download";

  window.open(url, "_blank");
};

document.addEventListener("DOMContentLoaded", () => {
  if (sidebarFiltersForm) {
    sidebarFiltersForm.addEventListener("submit", handleSearchSubmit);
  }

  delegate(".sidebar-filters-form input[type=checkbox]", "change", handleSidebarFilterChange);
  delegate("[data-sort]", "click", handleSortChange);
  delegate('[data-change-view]:not([aria-selected="true"])', "click", handleViewChange);
  delegate(".clear-all", "click", handleClearAll);
  delegate(".toolbar-print", "click", handlePrint);
  delegate(".toolbar-download", "click", handleDownload);
});
